import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { Provider } from 'react-redux';
import { store } from '../src/store/store.ts';
import AgoraRTC from 'agora-rtc-sdk-ng';
import { AgoraProvider } from './connectivity/agora/AgoraProvider';
import { ConsultationSocketProvider } from './connectivity/chat/ConsultationSocketProvider';
import { HelmetProvider } from 'react-helmet-async';
import { initializeGuestCountry } from './utils/guestCountry';

AgoraRTC.setLogLevel(3);
AgoraRTC.disableLogUpload();

// Max time we are willing to delay first render for country detection.
const COUNTRY_DETECTION_TIMEOUT_MS = 2000;

const waitForGuestCountry = async (): Promise<void> => {
  await Promise.race([
    initializeGuestCountry(),
    new Promise<void>((resolve) =>
      setTimeout(resolve, COUNTRY_DETECTION_TIMEOUT_MS),
    ),
  ]);
};

const bootstrap = async () => {
  // Make sure guest_country is in sessionStorage BEFORE any pricing
  // component mounts. initializeGuestCountry never throws (it returns
  // null on failure), so the app always renders.
  await waitForGuestCountry();

  createRoot(document.getElementById("root")!).render(
    <HelmetProvider>
      <Provider store={store}>
        <AgoraProvider>
          <ConsultationSocketProvider>
            <App />
          </ConsultationSocketProvider>
        </AgoraProvider>
      </Provider>
    </HelmetProvider>
  );

  requestAnimationFrame(() => {
    const loader = document.getElementById("initial-loader");
    if (loader) {
      loader.classList.add("fade-out");
      setTimeout(() => loader.remove(), 350);
    }
  });
};

bootstrap();